import { useState } from 'react';

import Avatar from 'components/@extended/Avatar';
import IconButton from 'components/@extended/IconButton';
import { ExpandMoreRounded as ExpandMoreRoundedIcon, LogoutOutlined } from 'components/icons';
import { SecurityModal } from 'components/modals/user/SecurityModal';
import { useModal } from 'components/modals/useModal';
import UserPreferencesModal from 'components/modals/user/UserPreferencesModal';
import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';
import { Tooltip } from 'components/ui/tooltip';
import useAuth from 'hooks/useAuth';
import { t } from 'utils/getTranslations.ts';
import StyledHeaderButton from '../actions/StyledHeaderButton';

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
    const { openModal, closeModal } = useModal();

    const { logout } = useAuth();

    const { user } = useAuth();
    const name = user?.name;
    const splitName = name ? name.split(' ') : ['', ''];
    const initials =
        splitName.length > 1
            ? `${splitName[0]?.[0] || 0}${splitName.pop()?.[0] || ''}`
            : splitName.length > 0
              ? splitName[0]
              : '';
    const handleLogout = async () => {
        try {
            await logout();
        } catch (err) {
            console.error(err);
        }
    };

    const [open, setOpen] = useState(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger render={<StyledHeaderButton className="shrink-0 px-3" />}>
                {splitName[0]}
                <ExpandMoreRoundedIcon strokeWidth={2} stroke="currentColor" className="text-[12px]" />
            </PopoverTrigger>
            <PopoverContent
                align="end"
                sideOffset={9}
                className="w-[290px] gap-2 px-5 pt-6 pb-5 leading-5.5 max-md:w-[250px]"
            >
                {/* Wraps, so a name too long to share the row pushes the logout button under it. */}
                <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center gap-2.5">
                        <Avatar alt="profile user" className="bg-primary text-primary-foreground size-8 text-[10px]">
                            {initials}
                        </Avatar>
                        <h6 className="text-h6">{name}</h6>
                    </div>
                    <Tooltip content="Logout">
                        <IconButton
                            size="large"
                            aria-label="Logout"
                            className="text-fg hover:text-fg"
                            onClick={() => {
                                void handleLogout();
                            }}
                        >
                            <LogoutOutlined />
                        </IconButton>
                    </Tooltip>
                </div>
                <button
                    type="button"
                    className="cursor-pointer text-left hover:underline"
                    onClick={() => {
                        setOpen(false);
                        openModal(<SecurityModal onClose={closeModal} />, closeModal);
                    }}
                >
                    {t('user.security-title')}
                </button>
                <button
                    type="button"
                    className="cursor-pointer text-left hover:underline"
                    onClick={() => {
                        setOpen(false);
                        openModal(<UserPreferencesModal onClose={closeModal} />, closeModal);
                    }}
                >
                    {t('user.preferences-selection')}
                </button>
            </PopoverContent>
        </Popover>
    );
};

export default Profile;
